module.exports = __webpack_public_path__ + "img/preview-6.07f46252.png";